export default "__VITE_ASSET__c0824920__"